import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';

const Backbtn = props => {
  const { t } = useTranslation();
  return (
    <div className="btn-container">
      <Link to="/">
        <button className="back-btn">{`< `} {t('backbtn')} </button>
      </Link>
    </div>
  );
};

export { Backbtn };
